import React, { useEffect, useRef } from 'react'
import Logo from "../images/logo.png";

const RealizedHeader = React.forwardRef((props, ref) => {
    const formatDate = (dateStr) => {
        const date = new Date(dateStr);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };


    const fromDate = formatDate(props.fromDate); // format 'fromDate'
    const toDate = formatDate(props.toDate); // format 'toDate'
    const headerStyle = {
        backgroundColor: '#004080',
        color: '#fff',
        fontSize: '12px',
        fontFamily: 'Roboto Regular',
        fontWeight: "normal",
        borderRight: '1px solid rgb(255 255 255 / 50%)',
        verticalAlign: 'middle',
        textAlign: "center"
    };

    const tdStyle = {
        background: '#e0e0e0',
        borderBottom: '1px solid #fff',
        borderRight: '1px solid rgb(255 255 255 / 50%)',
        padding: '2px 5px',
        color: "#000",
        fontSize: '12px',
    };

    const totalTd = {
        fontFamily: "Roboto Black",
        borderTop: '1px solid #000',
        borderBottom: '1px solid #000',
        padding: "6px",
        fontSize: "12px"
    };

    const total = {
        fontFamily: "Roboto Black",
        fontSize: "12px"
    };
    useEffect(() => {
        console.log("props. realized...", props);
    }, []);
    return (
        <div className="row m-0 pt-5" ref={ref}>
            <div className="col-4" style={{ lineHeight: '14px', fontSize: '14px' }}>
                <div style={{ fontFamily: "Roboto Black" }}>{props.clientAddressDetails.clientname}</div>
                <div>Building : {props.clientAddressDetails.building}</div>
                <div>Office or Flat No : {props.clientAddressDetails.officeno}</div>
                <div>Street : {props.clientAddressDetails.street}</div>
                <div>Post Box : {props.clientAddressDetails.postbox}</div>
                <div>Country : {props.clientAddressDetails.countrya}</div>
                <div>VAT TRN : {props.clientAddressDetails.trnno || "No"}</div>
                <div>From Date:{props.fromDate} </div>
                <div>To Date:{props.toDate} </div>
            </div>
            <div className="col-4 d-flex justify-content-center" style={{ fontSize: '17px', textAlign: 'center', padding: '0px 20px', fontFamily: '"Roboto Black"', display: 'flex', alignItems: 'center' }}>
                {props.headerName}
            </div>
            <div className="col-4 text-end" style={{ fontSize: '14px' }}>
                <div className="mb-1">
                    <img src={Logo} alt="Logo" className="img-fluid" width="160" height="130" />
                </div>
                <div>A/C No: <span style={{ fontFamily: "Roboto Black" }}>{props.clientAddressDetails.clientid}</span></div>
                {/* <div>Statement Date: <span style={{ fontFamily: "Roboto Black" }}>{fromDate}</span></div> */}
                <div>RM Name:{props.clientAddressDetails.RM_Name}</div>
                <div>Email:{props.clientAddressDetails.RM_Email}</div>
            </div>
        </div>
    );
});

export default RealizedHeader;
